import { formatNumber } from '../../util';

export function TableItemNumber ({ value, title, numberFormat, children, bold }) {
	if (!value || isNaN(value)) {
		return <span class="bold">-</span>;
	}
	return (<span class={bold ? 'bold' : null} title={title ? formatNumber(numberFormat, value) : null}>
		{children.length ? children : formatNumber(numberFormat, value)}
	</span>);
}



// WEBPACK FOOTER //
// ./components/table/table-item-number.js